"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { CircleCheck, Users, Clock, Award } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
export default function Benefit() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const benefits = [{
    icon: Users,
    title: "Expert UK‑qualified tutors",
    description: "Our team of experienced educators brings years of teaching expertise to every session."
  }, {
    icon: CircleCheck,
    title: "Confidence-focused learning approach",
    description: "We combine academic instruction with mindset coaching to build lasting confidence."
  }, {
    icon: Clock,
    title: "Personalised study plans tailored to each student",
    description: "Every programme is customised to meet individual learning goals and pace."
  }, {
    icon: Award,
    title: "Regular progress updates and feedback",
    description: "Stay informed with consistent reports on student achievement and areas for growth."
  }];
  return;
}